(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    class McSelect extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select || this.querySelector('.mc-select__button')) return;

      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.className = 'mc-select__button';
      this.button.setAttribute('aria-haspopup', 'listbox');
      this.button.setAttribute('aria-expanded', 'false');

      this.label = document.createElement('span');
      this.arrow = document.createElement('span');
      this.arrow.className = 'svg-wrapper';
      this.arrow.innerHTML = this.querySelector('.svg-wrapper') ? this.querySelector('.svg-wrapper').innerHTML : '';
      this.button.appendChild(this.label);
      this.button.appendChild(this.arrow);

      this.list = document.createElement('ul');
      this.list.className = 'mc-select__list';
      this.list.setAttribute('role', 'listbox');

      this.buildList();
      this.updateButtonLabel();

      this.appendChild(this.button);
      this.appendChild(this.list);

      this.button.addEventListener('click', () => this.toggle());
      this.select.addEventListener('change', () => {
        this.updateButtonLabel();
        this.updateActiveOption();
      });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });
    }

    buildList() {
      this.list.innerHTML = '';
      Array.from(this.select.options).forEach((option) => {
        const li = document.createElement('li');
        li.className = 'mc-select__option';
        li.setAttribute('role', 'option');
        li.textContent = option.textContent.trim();
        li.dataset.value = option.value;
        if (option.selected) li.classList.add('is-selected');
        li.addEventListener('click', () => this.selectOption(option.value));
        this.list.appendChild(li);
      });
    }

    updateButtonLabel() {
      const selected = this.select.options[this.select.selectedIndex];
      this.label.textContent = selected ? selected.textContent.trim() : '';
    }

    updateActiveOption() {
      this.list.querySelectorAll('.mc-select__option').forEach((li) => {
        li.classList.toggle('is-selected', li.dataset.value === this.select.value);
      });
    }

    selectOption(value) {
      this.select.value = value;
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
      this.updateButtonLabel();
      this.updateActiveOption();
      this.close();
    }

    toggle() {
      this.classList.toggle('is-open');
      this.button.setAttribute('aria-expanded', this.classList.contains('is-open'));
    }

    close() {
      this.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('mc-select')) {
    customElements.define('mc-select', McSelect);
  }
  } catch(e) { console.error(e); }
})();

})();
